// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let DebounceP = require("../../reason/common/DebounceP.bs.js");
let SearchField = require("../../reason/chapter/components/SearchField.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let ChapterMembersListItem = require("./ChapterMembersListItem.bs.js");
let HighlightSection__Jsx3 = require("../../uikit/reason/atoms/Sections/HighlightSection__Jsx3.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PaginationBoxRefetchable = require("../common/pagination/PaginationBoxRefetchable.bs.js");
let ChapterMembersListRelayQueryParams = require("./ChapterMembersListRelayQueryParams.bs.js");
let ChapterMembersListRelay_chapter_graphql = require("../../__generated__/ChapterMembersListRelay_chapter_graphql.bs.js");
let ChapterMembersListRelayPaginationQuery_graphql = require("../../__generated__/ChapterMembersListRelayPaginationQuery_graphql.bs.js");

let convertFragment = ChapterMembersListRelay_chapter_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ChapterMembersListRelay_chapter_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ChapterMembersListRelay_chapter_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ChapterMembersListRelay_chapter_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ChapterMembersListRelay_chapter_graphql.node, convertFragment, fRef);
}

let makeRefetchVariables = ChapterMembersListRelayPaginationQuery_graphql.Types.makeRefetchVariables;

let convertRefetchVariables = ChapterMembersListRelayPaginationQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(ChapterMembersListRelay_chapter_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

let ChapterFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable
};

function ChapterMembersListRelay(props) {
  let match = ChapterMembersListRelayQueryParams.use();
  let setQueryParams = match[1];
  let queryParams = match[0];
  let match$1 = useRefetchable(props.chapter);
  let refetch = match$1[1];
  let chapter = match$1[0];
  let match$2 = React.useTransition();
  let startTransition = match$2[1];
  let match$3 = React.useState(() => Stdlib_Option.getOr(queryParams.search, ""));
  let setSearchText = match$3[1];
  let searchText = match$3[0];
  let s = searchText.trim();
  let searchTextOpt = s === "" ? undefined : s;
  let search = React.useCallback(DebounceP.make(300, async searchText => startTransition(() => {
    refetch(makeRefetchVariables(Primitive_option.some(undefined), Primitive_option.some(undefined), 10, Primitive_option.some(undefined), chapter.nodeId, Primitive_option.some(searchText)), undefined, undefined);
  })), [
    refetch,
    startTransition
  ]);
  let match$4 = chapter.members;
  let tmp;
  if (match$4 !== undefined) {
    let match$5 = match$4.pageInfo;
    let startCursor = match$5.startCursor;
    let endCursor = match$5.endCursor;
    let members = Stdlib_Array.keepSome(Stdlib_Option.getOr(match$4.edges, [])).map(e => e.node);
    let search$1 = Stdlib_Option.getOr(Stdlib_Option.map(searchTextOpt, s => `&search=` + encodeURIComponent(s)), "");
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        members.length !== 0 ? JsxRuntime.jsx("div", {
            children: members.map(agent => JsxRuntime.jsx(ChapterMembersListItem.make, {
              agent: agent.fragmentRefs
            }, agent.id)),
            className: "flex flex-col space-y-4 mt-4"
          }) : JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(HighlightSection__Jsx3.make, {
              background: "Muted",
              children: "No members match your search"
            }),
            className: "mt-4"
          }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(PaginationBoxRefetchable.make, {
            previousPagePath: match$5.hasPreviousPage ? (
                startCursor !== undefined ? `?before=` + startCursor + search$1 : "#"
              ) : undefined,
            onClickPrevious: () => {
              startTransition(() => {
                refetch(makeRefetchVariables(Primitive_option.some(undefined), Primitive_option.some(startCursor), Primitive_option.some(undefined), 10, chapter.nodeId, Primitive_option.some(searchText)), undefined, undefined);
              });
              setQueryParams("replace", {
                after: undefined,
                before: startCursor,
                search: searchTextOpt
              });
            },
            nextPagePath: match$5.hasNextPage ? (
                endCursor !== undefined ? `?after=` + endCursor + search$1 : "#"
              ) : undefined,
            onClickNext: () => {
              startTransition(() => {
                refetch(makeRefetchVariables(Primitive_option.some(endCursor), Primitive_option.some(undefined), 10, Primitive_option.some(undefined), chapter.nodeId, Primitive_option.some(searchText)), undefined, undefined);
              });
              setQueryParams("replace", {
                after: endCursor,
                before: undefined,
                search: searchTextOpt
              });
            }
          }),
          className: "mt-8 text-center"
        })
      ]
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(SearchField.make, {
          value: searchText,
          placeholder: "Search for members",
          onChange: evt => {
            let value = evt.target.value;
            setSearchText(param => value);
            search(value);
            setQueryParams("replace", {
              after: undefined,
              before: undefined,
              search: value
            });
          }
        }),
        className: "mt-8"
      }),
      tmp
    ]
  });
}

let make = ChapterMembersListRelay;

exports.ChapterFragment = ChapterFragment;
exports.make = make;
/* react Not a pure module */
